export const schoolMapping = {
    'Carleton University': 'Carleton University',
    'University of Ottawa': 'uOttawa',
    'Algonquin College': 'Algonquin College',
  };